import { put, takeEvery } from "redux-saga/effects";
import { GET_IMAGE_UPLOAD, GET_USER, GET_USER_UPDATE, SET_USER } from "../ConstAction";
import UserApiRequests from "../../Services/User";
import { storage } from "../../Config/Storage";

function* getimguploaded(data) {
    try {
        let response = yield UserApiRequests.requestimguploaded(data.data, data.file_id);
        if (response) {
            for (let [key, value] of data.data.entries()) {
                if (key === 'folder') {
                    if (value === 'c5966b2f-11dc-44d5-a273-de155ae10e92') {
                        yield put({
                            type: GET_USER_UPDATE,
                            response: { avatar: response?.data?.data?.id },
                            data: { user_id: storage.fetch.phone() },
                            setLoading: data.setLoading
                        })
                    } else {
                        yield put({
                            type: GET_USER_UPDATE,
                            response: { bg_img: response?.data?.data?.id },
                            data: { user_id: storage.fetch.phone() },
                            setLoading: data.setLoading
                        })
                    }
                }
            }
        }

    } catch (err) {
        data.setLoading(false)

    }
}

function* getuserupdate(data) {
    try {
        let response = yield UserApiRequests.requestuserupdate(data.response, data.data.user_id);
        if (response) {
            yield put({
                type: SET_USER,
                response
            })
            storage.set.loggedinuser(response?.data?.data)
        }
        data.setLoading(false)
    } catch (err) {
        data.setLoading(false)

    }
}

function* getuser(data) {
    
    try {
        let response = yield UserApiRequests.requestuser(data.data);
        storage.set.loggedinuser(response?.data?.data)
        yield put({
            type: SET_USER,
            response,
        })
        data.setLoading(false)

    } catch (err) {
        data.setLoading(false)
    }
}
// Defination of all Saga
function* Usersaga() {
    yield takeEvery(GET_IMAGE_UPLOAD, getimguploaded);
    yield takeEvery(GET_USER_UPDATE, getuserupdate);
    yield takeEvery(GET_USER, getuser);
}
export default Usersaga;